import type { ComponentProps } from 'react';

import { cn } from '../cn';

/**
 * Drawn rather than set as ☰ and ✕: the two characters are not the same weight
 * or optical size in any face, so the control changed shape with its state.
 */
const stroke = {
  stroke: 'currentColor',
  strokeWidth: 2.5,
  strokeLinecap: 'round',
} as const;

export const MenuIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
    className={cn('size-6', className)}
    {...props}>
    {/* 6.5 apart rather than 5: at 5 the three read as a block. */}
    <path d='M3.5 5.5h17M3.5 12h17M3.5 18.5h17' {...stroke} />
  </svg>
);

export const CloseIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
    className={cn('size-6', className)}
    {...props}>
    <path d='M5.5 5.5l13 13M18.5 5.5l-13 13' {...stroke} />
  </svg>
);
